import { Button, useLocalization, IconDownload } from '@magicdoorinc/ui';
import { createSignal } from 'solid-js';
import AuthLogsModal from './AuthLogsModal';
import type { Component } from 'solid-js';

const ExportAuthLogsButton: Component = () => {
  const { t } = useLocalization();
  const [isModalOpen, setIsModalOpen] = createSignal(false);

  return (
    <>
      <div class="px-2">
        <Button
          variant="text"
          size="xs"
          onClick={() => setIsModalOpen(true)}
          class="flex items-center gap-1.5 text-gray-600 hover-allowed:hover:bg-gray-100">
          <>
            <IconDownload class="size-3" />
            <span class="text-xs font-medium">{t('Logs')}</span>
          </>
        </Button>
      </div>

      <AuthLogsModal isOpen={isModalOpen()} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default ExportAuthLogsButton;
